"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveCooperationAgreementsDto = void 0;
const class_validator_1 = require("class-validator");
const get_cooperation_agreements_types_1 = require("../../../../../domain/drivers/cooperation-agreement/types/get-cooperation-agreements.types");
class RetrieveCooperationAgreementsDto {
}
exports.RetrieveCooperationAgreementsDto = RetrieveCooperationAgreementsDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(get_cooperation_agreements_types_1.CooperationAgreementStatus),
    __metadata("design:type", String)
], RetrieveCooperationAgreementsDto.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", Object)
], RetrieveCooperationAgreementsDto.prototype, "departureAtFrom", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", Object)
], RetrieveCooperationAgreementsDto.prototype, "departureAtTo", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)("4", { each: true }),
    __metadata("design:type", Array)
], RetrieveCooperationAgreementsDto.prototype, "countryIds", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], RetrieveCooperationAgreementsDto.prototype, "limit", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], RetrieveCooperationAgreementsDto.prototype, "offset", void 0);
//# sourceMappingURL=cooperationAgreementTypes.js.map